import type {
    ResourceId,
    SupplyEditionInput,
    SupplyId,
    SupplySummary,
    Url,
} from '@wwf/sdk';
import { RAFile } from './types';

export type SupplyInput = SupplyEditionInput & {
    id?: SupplyId;
    imageInput?: RAFile;
};

export type SupplyFormValues = {
    name: string;
    description: string | null;
    enabled: boolean;
    price: string | null;
    noPrice: boolean;
    type: string | null;
    target: string | null;
    link: Url | null;
    imageId?: ResourceId | null;
    imageInput?: RAFile;
};

export function supplySummaryToFormValues(
    summary: SupplySummary
): SupplyFormValues {
    const {
        image,
        createdAt,
        updatedAt,
        organizationId,
        inventoryCount,
        inventoryComment,
        available,
        price,
        ...edition
    } = summary;

    return {
        name: edition.name ?? '',
        description: edition.description ?? null,
        enabled: edition.enabled ?? true,
        price: price ?? null,
        noPrice: price == null,
        type: edition.type ?? null,
        target: edition.target ?? null,
        link: edition.link ?? null,
        imageId: image?.id ?? null,
        imageInput: undefined,
    };
}
